import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";

export const useIsUserExpert = async () => {
    const response = await axiosInstance.get(`${axiosPath.isUserExpert}`);
    return response;
};
